import { render, staticRenderFns } from "./MStoreSpinnerButton.vue?vue&type=template&id=880368ac&scoped=true&"
import script from "./MStoreSpinnerButton.vue?vue&type=script&lang=ts&"
export * from "./MStoreSpinnerButton.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreSpinnerButton.vue?vue&type=style&index=0&id=880368ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880368ac",
  null
  
)

export default component.exports